import { useTranslation } from "react-i18next";
import { FINANCIAL_TEAM_CODE, IncomePageType } from "../../../../constans";
import Button from "../../../Button";
import { IGetIncome } from "../../../../models/financials.model";
import useAxios from "../../../../hooks/useAxios";
import { deleteAdminIncome, getIncome } from "../../../../api/financials.api";
import { useEffect, useState } from "react";
import { getCommonCodeLabel } from "../../../../lib/store";
import moment from "moment";
import { useSelector } from "react-redux";
import { RootState } from "../../../../store/rootReducer";
import useNotification from "../../../../hooks/useNotification";
import { IResponse } from "../../../../models/common.api.model";
import ConfirmModal from "../../../modals/ConfirmModal";

interface IProps {
    incomeCode: number,
    commonCode: string,
    setPageType: (param: IncomePageType) => void;
    getIncomeList: (listType: 'A' | 'P') => void;
}

const IncomeRead = ({incomeCode, commonCode, setPageType, getIncomeList} : IProps) => {
    const [confirmAdminDeleteVisible, setConfirmAdminDeleteVisible] = useState(false);
    const { t, i18n } = useTranslation();
    const { auth } = useSelector((state: RootState) => state.auth);
    const { successNotification, errorNotification } = useNotification();

    const { data: incomeDetail, isLoading, error, execute: executeDetail } = useAxios<IGetIncome>();
    const { data: delIncomeResult, isLoading : loading2, error : delError, execute: executeDelncome } = useAxios<IResponse<Number>>();

    useEffect(() => {
        getIncomeDetail();
    }, [incomeCode]);

    const getIncomeDetail = () => {
        executeDetail(getIncome(incomeCode, commonCode));
    }

    const onAdminDeleteButton = () => {
        executeDelncome(deleteAdminIncome(incomeCode));
    }

    useEffect(() => {
        if(error) {
            if (!error?.response?.status) return;
            if(error.response?.data.data === 'CC') {
                errorNotification(t('payment.income.error1'));
            } else {
                errorNotification(t('common.message.error'));
            }
        }
    }, [error]);

    useEffect(() => {
        if(delIncomeResult) {
            if(delIncomeResult.result === "success") {
                successNotification(t('common.message.delete'));

                getIncomeList('A');
                setPageType(IncomePageType.CREATE);
            }
        }
    }, [delIncomeResult]);

    return(
        <>
            <div className="comm-bx__between">  
                <h3 className='sub-title'>{t('payment.income.title3')}</h3>
            </div>
            <div className="comm-table__area rowType">
                <table>
                    <colgroup>
                        <col width="15%" />
                        <col width="85%" />
                    </colgroup>
                    <tbody>
                        <tr>
                            <th>{t('system.treecode.account1')}</th>
                            <td>
                                {i18n.language === 'ko' ? incomeDetail?.data?.firstIncomeAccName : incomeDetail?.data?.firstIncomeAccEngName}
                            </td>
                        </tr>
                        <tr>
                            <th>{t('system.treecode.account2')}</th>
                            <td>
                                {i18n.language === 'ko' ? incomeDetail?.data?.secondIncomeAccName : incomeDetail?.data?.secondIncomeAccEngName}
                            </td>
                        </tr>
                        <tr>
                            <th>{t('system.treecode.account3')}</th>
                            <td>
                                {i18n.language === 'ko' ? incomeDetail?.data?.thirdIncomeAccName : incomeDetail?.data?.thirdIncomeAccEngName} 
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="comm-table__area rowType">
                <table>
                    <colgroup>
                        <col width="15%" />
                        <col width="35%" />
                        <col width="15%" />
                        <col width="35%" />
                    </colgroup>
                    <tbody>
                        <tr>
                            <th>{t('student.student.62')}</th>
                            <td>{moment(incomeDetail?.data?.registDate).format("YYYY-MM-DD")}</td>
                            <th>{t('payment.income.column1')}</th>
                            <td>{moment(incomeDetail?.data?.incomeDate).format("YYYY-MM-DD")}</td>
                        </tr>
                        <tr>
                            <th>{t('payment.income.search3')}</th>
                            <td>
                                {getCommonCodeLabel('FB0002', incomeDetail?.data?.incomeMtd, i18n.language)}
                            </td>
                            <th>{t('payment.income.search4')}</th>
                            <td>
                                {getCommonCodeLabel('FB0003', incomeDetail?.data?.incomeYn, i18n.language)}
                            </td>
                        </tr>
                        <tr>
                            <th>{t('payment.income.column3')}</th>
                            <td>
                                {getCommonCodeLabel('FB0004', incomeDetail?.data?.currency, i18n.language)}
                            </td>
                            <th>{t('payment.income.column4')}</th>
                            <td>
                                <div className="flex" style={{alignItems:'center', gap:'5px'}}>
                                    {incomeDetail?.data?.amount.toLocaleString()}
                                    <b>{t('campus.setting.text2')}</b>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th>{t('payment.income.search5')}</th>
                            <td colSpan={3}>
                                <div className="w-100">
                                    {incomeDetail?.data?.incomeDesc}
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th>{t('common.column.file')}</th>
                            <td colSpan={3}>
                                {
                                    incomeDetail?.data?.files
                                        ? (<>
                                            {
                                                incomeDetail?.data.files.map((item: any) => (
                                                    <a
                                                      className="download-link btn-text mr-1 attach-break"
                                                      href={item.fileLocation}
                                                      download={item.originalName}
                                                    >
                                                      {item.originalName}
                                                    </a>
                                                ))
                                            } 
                                        </>) 
                                    : null
                                }
                            </td>
                        </tr>
                        <tr>
                            <th>{t('common.text.note')}</th>
                            <td colSpan={3}>
                                <textarea
                                    className="w-100"
                                    rows={5}
                                    value={incomeDetail?.data?.note}
                                />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            {(auth.groupNo === FINANCIAL_TEAM_CODE && incomeDetail?.data?.completeYn === 'N') && (
                <div className="comm-bx__between">
                    <div></div>
                    <div className="comm-btn__area">
                    <Button
                        onClick={()=>{setConfirmAdminDeleteVisible(true)}}
                        className="btn-basic gray"
                        text={t('common.button.delete')}
                    />
                    </div>
                </div>
            )}
            {(incomeDetail?.data?.memberCode === auth.memberCode && incomeDetail?.data?.completeYn === 'N') &&
                <div className="comm-bx__between">
                    <div></div>
                    <div className="comm-btn__area">
                        <Button
                            onClick={()=>{setPageType(IncomePageType.UPDATE)}}
                            className="btn-basic pink-line"
                            text={t('common.button.edit')}
                            /*writeAuthYn={writeAuthYn}*/
                        />
                    </div>
                </div>
            }

            {confirmAdminDeleteVisible && (
                <ConfirmModal
                visible={confirmAdminDeleteVisible}
                setVisible={setConfirmAdminDeleteVisible}
                onConfirm={onAdminDeleteButton}
                titleText={t('system.menu.title6')}
                messageText={t('system.menu.text3')}
                confirmText={t('common.button.delete')}
                cancelText={t('common.button.cancel')}
                />
            )}
        </>
    )
}

export default IncomeRead;